import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges } from "@angular/core";
import { MatProgressBarModule } from "@angular/material/progress-bar";

@Component({
    selector: "vui-progress-bar",
    templateUrl: "./progress-bar.component.html",
    styleUrls: ["./progress-bar.component.scss"],
    standalone: true,
    imports: [CommonModule, MatProgressBarModule],
})
export class ProgressBarComponent implements OnChanges {
    @Input() mode: "determinate" | "indeterminate" = "indeterminate";
    @Input() progress: number = 0;

    ngOnChanges(): void {
        if (this.progress < 0) this.progress = 0;
        if (this.progress > 100) this.progress = 100;
    }
}
